import { supabase } from '../client';

export interface OrgMatchingConfig {
  id: string;
  org_id: string;
  weight_skill_overlap: number;
  weight_experience_alignment: number;
  weight_education_fit: number;
  weight_salary_fit: number;
  weight_cultural_fit: number;
  pinecone_namespace: string | null;
  created_at: string;
  updated_at: string;
}

const DEFAULT_WEIGHTS = {
  weight_skill_overlap: 0.40,
  weight_experience_alignment: 0.25,
  weight_education_fit: 0.15,
  weight_salary_fit: 0.10,
  weight_cultural_fit: 0.10,
};

export const orgMatchingConfigService = {
  async getForOrg(orgId: string): Promise<OrgMatchingConfig> {
    const { data, error } = await supabase
      .from('ggj_b2b_org_matching_config')
      .select('*')
      .eq('org_id', orgId)
      .maybeSingle();
    if (error) throw error;
    if (data) return data as OrgMatchingConfig;

    const { data: created, error: createErr } = await supabase
      .from('ggj_b2b_org_matching_config')
      .insert({ org_id: orgId })
      .select('*')
      .single();
    if (createErr) throw createErr;
    return created as OrgMatchingConfig;
  },

  async update(
    orgId: string,
    patch: Partial<
      Pick<
        OrgMatchingConfig,
        | 'weight_skill_overlap'
        | 'weight_experience_alignment'
        | 'weight_education_fit'
        | 'weight_salary_fit'
        | 'weight_cultural_fit'
        | 'pinecone_namespace'
      >
    >,
  ): Promise<OrgMatchingConfig> {
    const { data, error } = await supabase
      .from('ggj_b2b_org_matching_config')
      .update(patch)
      .eq('org_id', orgId)
      .select('*')
      .single();
    if (error) throw error;
    return data as OrgMatchingConfig;
  },

  defaultWeights(): typeof DEFAULT_WEIGHTS {
    return { ...DEFAULT_WEIGHTS };
  },

  /**
   * Resolve the Pinecone namespace for an org.
   * Falls back to `org-{orgId}` if no custom namespace is set.
   */
  resolvePineconeNamespace(config: OrgMatchingConfig): string {
    return config.pinecone_namespace?.trim() || `org-${config.org_id}`;
  },
};
